import { Button, Col, Flex, Layout, message, Row, Spin, Tooltip, Typography } from 'antd';
import Heading from '../Heading/Heading ';
import PriceWithUnit from '../Price/PriceWithUnit';
import { InformationIcon, CashIcon, RightIcon, VaultIcon, WarningModalIcon } from '../Icons';
import { useTranslation } from 'react-i18next';
import { LOCAL_AR, ROUTE, THEME_VARIABLE } from '@/config';
import { useCreateRemittance } from '@/hooksApi/useRemittance';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import CustomModal from '../Modal/Modal';
import { Link } from 'react-router-dom';
import useLanguageStore from '@/stores/useLanguageStore';

const { Text } = Typography;

interface CardAvailableCodDashboardProps {
  availableCOD: number;
  loadingAvailableCod: boolean;
}

const CardAvailableCodDashboard = ({
  loadingAvailableCod,
  availableCOD,
}: CardAvailableCodDashboardProps) => {
  const [modalWithdraw, setModalWithdraw] = useState<boolean>(false);
  const { t } = useTranslation();
  const { mutate, isLoading } = useCreateRemittance();
  const queryClient = useQueryClient();
  const { language } = useLanguageStore();

  return (
    <Layout className='h-[123px] bg-white flex flex-col rounded-[10px] border-customGrayShade3 border-[1px] shadow-card-dark justify-between items-stretch p-4'>
      <Row className='flex flex-row justify-between h-full gap-1'>
        <Col md={24}>
          <Flex className='flex justify-between'>
            <Flex className='gap-x-1 flex items-center mb-auto'>
              <Text className='font-bold text-base leading-[23.2px] text-customTunaPrimary'>
                {t('available_cod')}
              </Text>
              <Tooltip title={t('the_balance_that_you_can_withdraw')}>
                <InformationIcon width={16} height={16} color={THEME_VARIABLE.customGrayShade5} />
              </Tooltip>
            </Flex>
            <Link
              to={ROUTE.FINANCE}
              className='flex items-center h-[18px] px-1 bg-customGrayShade3 rounded-md'
            >
              <Heading
                title={t('more')}
                trailingIcon={
                  <RightIcon
                    className={`${language === LOCAL_AR ? 'rotate-180' : ''}`}
                    width={13}
                    height={13}
                  />
                }
                color='text-customGrayShade5'
                fontSize='text-xs'
                parentClassName='gap-1'
              />
            </Link>
          </Flex>
        </Col>

        <Col md={24}>
          {loadingAvailableCod ? (
            <Spin />
          ) : (
            <Flex vertical>
              <Flex align='center' gap={'.25rem'}>
                <Flex className='w-10 h-10 bg-customGrayShade2 rounded-full flex justify-center items-center'>
                  <VaultIcon width={24} height={24} />
                </Flex>
                <PriceWithUnit
                  value={availableCOD}
                  color={THEME_VARIABLE.customTunaPrimary}
                  subTitle={t('iqd')}
                  size='md'
                  fontSize={'40px'}
                  fontSizeSub='text-2xl'
                />
              </Flex>

              {/* <Row className='flex items-center gap-1'>
                    <Flex align='center' className='gap-x-1'>
                      <UpCircleOutlineIcon />
                      <Text className={STYLE_TEXT_COD}>15%</Text>
                    </Flex>
                  <Text className={STYLE_TEXT_COD}>+350,000 {t('iqd')}</Text>
                  <Text className='text-xs font-medium text-customTunaPrimary'>{t('from')}</Text>
                </Row> */}
            </Flex>
          )}
        </Col>
      </Row>

      {/* <LineChartItem /> */}

      {/* modal widthdraw */}
      {modalWithdraw && (
        <CustomModal
          visible={modalWithdraw}
          onClose={() => setModalWithdraw(false)}
          title={t('withdraw')}
          footer={false}
        >
          <Flex vertical>
            <Flex vertical className=' items-center mt-8'>
              <WarningModalIcon />
              <Heading
                title={t('You_will_be_withdrawing_all_of_your_current_balance')}
                extraClassName='my-8'
                level={5}
              />
            </Flex>
            <Flex className='justify-end w-full'>
              <Button
                type='primary'
                className='w-28'
                onClick={() =>
                  mutate(
                    {},
                    {
                      onSuccess: () => {
                        message.success(t('operation'));
                        queryClient.refetchQueries(['availableCod']);
                        setModalWithdraw(false);
                      },
                    },
                  )
                }
              >
                {t('confirm')}
              </Button>
            </Flex>
          </Flex>
        </CustomModal>
      )}
    </Layout>
  );
};

export default CardAvailableCodDashboard;
